/** Download only a verified PDF response, never an error body or an upstream filename. */
export const MAX_INVOICE_PDF_BYTES = 25 * 1024 * 1024;

export function invoicePdfFilename(rows) {
  if (rows.length !== 1) return 'medeffects-invoices.pdf';
  const number = String(rows[0]?.docNumber || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60);
  return number ? `invoice-${number}.pdf` : 'invoice.pdf';
}

function signature(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Invoice PDF could not be read.'));
    reader.onload = () => resolve(String(reader.result));
    reader.readAsText(blob.slice(0, 5), 'ascii');
  });
}

export async function saveInvoicePdf(response, filename, { isCurrent }) {
  if (!isCurrent()) return false;
  const blob = response?.data;
  const header = response?.headers?.get?.('content-type') || response?.headers?.['content-type'];
  const type = String(header || blob?.type || '').split(';')[0].trim().toLowerCase();
  if (!(blob instanceof Blob) || type !== 'application/pdf' || blob.size < 8 || blob.size > MAX_INVOICE_PDF_BYTES) {
    throw new Error('Invoice PDF could not be verified.');
  }
  if (await signature(blob) !== '%PDF-') throw new Error('Invoice PDF could not be verified.');
  // A logout, scope change or route change while the bytes were read must not save the old PDF.
  if (!isCurrent()) return false;
  const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  let link;
  try {
    link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    return true;
  } finally {
    link?.remove();
    // Give the browser time to consume the download before releasing its temporary URL.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
